import React from 'react'

interface TableBodyProps extends Omit<React.HTMLAttributes<HTMLTableSectionElement>, 'className'> {
  children: React.ReactNode;
}

export function TableBody ({ children, ...props }: TableBodyProps) {
  return (
    <tbody {...props}>
      {children}
    </tbody>
  )
}

TableBody.displayName = 'Table.Body'
